import { KYMW2400Model } from '../../kymw2400/kymw2400.model';
import { PageTemplateModel } from '../../kymw2400/vo/page-template.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * 新規ページ作成コマンド。
 * 管理クラスに新規で作成するページのデータを渡し、ページを作成してもらう。
 *
 * @export CreateNewPageService
 * @class CreateNewPageService
 */
@Injectable()
export class CreateNewPageService {

  /** 処理に使用するModel */
  private model: KYMW2400Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2400Model} model モデルクラス
   * @param {PageTemplateModel} vo パラメータ
   * @memberof CreateNewPageService
   */
  execute(model: KYMW2400Model, vo: PageTemplateModel) {
    this.model = model;
    this.model.createNewPage(vo);
  }
}
